/* Validated public application. Versioned intake stores full answers and returns explicit customer-operation status. Pending account creation is retried with the same submission UUID. */
(function () {
  'use strict';
  function trk(event, data, opts) { if (window.stellar && window.stellar.track) return window.stellar.track(event, data, opts); }

  /* stepped form: options advance on their own, typed steps need Next, the last step submits */
  function stepped(root) {
    if (root.dataset.sxvOn) return; root.dataset.sxvOn = '1';
    var f = root.tagName === 'FORM' ? root : root.querySelector('form'); if (!f) return;
    var steps = Array.prototype.slice.call(f.querySelectorAll('.step')), last = steps.length, i = 0;
    var back = f.querySelector('[data-back]'), next = f.querySelector('[data-next]'), submit = f.querySelector('[data-submit]'), bar = f.querySelector('.bar i');
    if (!steps.length || !next || !submit) return;
    if (root.hasAttribute('data-application')) { f.setAttribute('data-application', ''); ['data-klaviyo-list', 'data-program', 'data-role'].forEach(function (k) { if (root.getAttribute(k)) f.setAttribute(k, root.getAttribute(k)); }); if (!f.querySelector('input[type=password]')) f.setAttribute('data-klaviyo-off', ''); }
    var advanceTimer = null;
    function cancelAdvance() {
      if (advanceTimer !== null) { clearTimeout(advanceTimer); advanceTimer = null; }
    }
    function queueAdvance(input) {
      cancelAdvance();
      var expected = i, step = steps[i];
      if (!step || !step.contains(input) || i >= last - 1) return;
      advanceTimer = setTimeout(function () {
        advanceTimer = null;
        if (i === expected && steps[i] === step && !step.hidden && input.checked && valid()) show(expected + 1);
      }, 260);
    }
    function show(n) { cancelAdvance();
      i = Math.max(0, Math.min(n, last - 1)); steps.forEach(function (st, k) { st.hidden = k !== i; });
      var lastQ = i === last - 1;
      if (back) back.hidden = i === 0; next.hidden = lastQ; submit.hidden = !lastQ;
      if (bar) bar.style.width = Math.round(((i + 1) / last) * 100) + '%';
      var el = steps[i].querySelector('input:not([type=radio]):not([type=checkbox]):not([type=hidden]),textarea'); if (el && i > 0) setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (e) {} }, 350);
      trk('form_step_viewed', { form: f.id || 'form', step: i + 1, of: last, question: (steps[i].querySelector('.q') || {}).textContent || '' }, { el: f });
    }
    function valid(){return window.stellar.formAdapters.validate(steps[i]);}
    f.addEventListener('change', function (e) { if (e.target.type === 'radio' && i < last - 1) queueAdvance(e.target); });
    next.addEventListener('click', function () { if (valid()) show(i + 1); });
    if (back) back.addEventListener('click', function () { show(i - 1); });
    var x0 = null;
    f.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    f.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 60) return; if (dx < 0 && i < last - 1 && valid()) show(i + 1); if (dx > 0 && i > 0) show(i - 1); }, { passive: true });
    var adapter=window.stellar.formAdapters;
    var intakeId=f.id==='event-add'?'event_creation_request':'venue_application';
    adapter.bind({form:f,button:submit,formId:intakeId,
      isFinalStep:function(){return i===last-1;},nextStep:function(){if(valid())show(i+1);},
      validate:function(){for(var k=0;k<last;k++){show(k);if(!valid())return false;}return true;},
      payload:function(){
        
        var p=adapter.fromForm(f,intakeId,{includeHidden:true,purpose:f.id==='event-add'?'operational':'lead'});
        delete p.fields.body;delete p.field_labels.body;
        return p;
      },
      isComplete:function(receipt){return intakeId==='event_creation_request'||adapter.applicationComplete(receipt);},
      onAccepted:async function(receipt){
        if(intakeId==='event_creation_request')adapter.showSaved(f,'Thank you — your request has been received.');
        else adapter.applicationReceipt(f,submit,receipt);
      }
    });
    show(root.querySelector('.errors') ? last - 1 : 0);
  }

  /* the application: file the labelled answers in the warehouse and Klaviyo before the page posts to Shopify.
     The form carries a password, so the data layer's own form capture leaves it alone; this is the one place it is recorded. */

  function label(name) { return String(name).replace(/^customer\[note\]\[|^customer\[|^contact\[|\]$/g, '').trim(); }

  /* the venue room: sub-nav follows the chapter in view; copy buttons */
  function subnav(nav) {
    if (nav.dataset.sxvOn || !('IntersectionObserver' in window)) return; nav.dataset.sxvOn = '1';
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (!en.isIntersecting) return; links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + en.target.id); }); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) io.observe(t); });
  }
  function copyBtn(b) {
    if (b.dataset.sxvOn) return; b.dataset.sxvOn = '1';
    b.addEventListener('click', function () {
      var src = b.closest('[data-copy-root]') || b.parentElement.parentElement, t = (src.querySelector('[data-copy-text]') || {}).textContent || '';
      try { navigator.clipboard.writeText(t.trim()); } catch (e) {}
      var was = b.textContent; b.textContent = b.getAttribute('data-copied') || 'Copied'; setTimeout(function () { b.textContent = was; }, 1400);
      trk('caption_copied', { title: b.getAttribute('data-title') || '' }, { el: b });
    });
  }

  function init(root) {
    if (root.matches('[data-steps]')) stepped(root); else root.querySelectorAll('[data-steps]').forEach(stepped);
    root.querySelectorAll('[data-subnav]').forEach(subnav);
    root.querySelectorAll('[data-copy]').forEach(copyBtn);
  }
  function boot() { document.querySelectorAll('[data-sxv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-sxv]').forEach(init); });
})();
